import React from "react";
import { Box, Typography, Grid2 as Grid } from "@mui/material";
import { useEntityHandlerContext } from "../../../controllers/entityController";

interface ViewTextFieldProps {
  name: string;
  label: string;
  textParser?: (value: any) => string;
}

/**
 * Display component for a text field in view mode.
 * Shows label and value, with "N/A" for empty values.
 */
const ViewTextField: React.FC<ViewTextFieldProps> = ({
  name,
  label,
  textParser,
}) => {
  const { methods } = useEntityHandlerContext();
  const data = methods.getValues();
  const rawValue = data?.[name as keyof typeof data];

  let displayValue: string = "N/A";
  if (rawValue !== undefined && rawValue !== null && rawValue !== "") {
    // Pass raw value to textParser (matching FormTextField behavior)
    displayValue = textParser ? textParser(rawValue) : String(rawValue);
  }

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 0.5 }}
        >
          {label}
        </Typography>
        <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
          {displayValue}
        </Typography>
      </Box>
    </Grid>
  );
};

export default ViewTextField;
